import { useEffect } from "react";

const CookieBanner = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/silktide-consent-manager.js";
    script.async = true;
    script.onload = () => {
      if (window.silktideCookieBannerManager) {
        window.silktideCookieBannerManager.updateCookieBannerConfig({
          background: { showBackground: false },
          cookieIcon: { position: "bottomRight" },
          cookieTypes: [
            {
              id: "google_analytics",
              name: "Google Analytics",
              description: "<p>Google Analytics uses cookies. These can be switched off.&nbsp;</p>",
              required: false,
              onAccept: function () {
                if (typeof window.gtag === "function") {
                  window.gtag("consent", "update", { analytics_storage: "granted" });
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({ event: "consent_accepted_google_analytics" });
                }
                hideCookieIcon(); // Hide the cookie icon after consent is accepted
              },
              onReject: function () {
                if (typeof window.gtag === "function") {
                  window.gtag("consent", "update", { analytics_storage: "denied" });
                }
                hideCookieIcon(); // Hide the cookie icon after consent is rejected
              },
            },
          ],
          text: {
            banner: {
              description:
                "<h3 class='is-bold'>Hey there! 🍪</h3><p>Nudgemail uses Google Analytics to learn how you surf our website. Google Analytics uses cookies to track interactions—nothing creepy, just insights to improve your experience. If you reject cookies, no hard feelings—we'll assume you enjoy a little mystery. 😉</p>",
              acceptAllButtonText: "Accept",
              rejectNonEssentialButtonText: "Reject",
              preferencesButtonText: "Preferences",
            },
            preferences: {
              title: "Cookie preferences",
              description: "<p>The team at Nudgemail respects your right to privacy.</p>",
            },
          },
          position: { banner: "bottomRight" },
        });
      }

      // Function to hide the cookie icon after user selection
      function hideCookieIcon() {
        const icon = document.getElementById("silktide-cookie-icon");
        if (icon) {
          icon.style.display = "none";
        }
      }

      // Check if user already made a choice and hide the icon
      setTimeout(() => hideCookieIcon(), 500);
    };
    document.body.appendChild(script);
  }, []);

  return <link rel="stylesheet" id="silktide-consent-manager-css" href="/silktide-consent-manager.css" />;
};

export default CookieBanner;
